<template>
  <div>
    <v-form>
      <v-text-field
        v-if="context !== 'create'"
        v-model="localReport.name"
        :label="$tc('name')"
        :error-messages="nameErrors"
        prepend-inner-icon="mdi-form-textbox"/>
      <date-picker
        v-model="compareDate"
        type="month"
        :timezone="timezone"
        :output-moment="true"
        :today="false"
        :max="maxDate"
        :label="$t('reports_ui.customer_metrics_report.compare_to_month')"
        prepend-inner-icon="mdi-calendar" />
    </v-form>
  </div>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import ValidationMixin from '@/components/mixins/ValidationMixin'
import ReportFormMixin from '@/components/report/ReportFormMixin'
import DatePicker from '@/components/shared/DatePicker'
import Moment from 'moment-timezone'
import { requiredIf } from 'vuelidate/lib/validators'
import { map, get } from 'lodash'

export default {
  name: 'MissedStopsReportForm',
  components: {
    DatePicker
  },
  mixins: [
    CurrentUserMixin,
    ApiUtilitiesMixin,
    ValidationMixin,
    ReportFormMixin
  ],
  validations: {
    localReport: {
      name: {
        required: requiredIf(function () {
          return this.action !== 'create'
        })
      }
    }
  },
  data () {
    return {
      reportType: 'CustomerMetricsReport',
      compareDate: null
    }
  },
  computed: {
    /**
     * Create and return a default report name for this report based on the current date.
     */
    maxDate () {
      return Moment().tz('UTC').subtract(1, 'month').endOf('month').toISOString()
    },
    nameErrors () {
      return this.validationErrors([{
        prop: this.$v.localReport.name,
        message: this.$t('required')
      }])
    }
  },
  methods: {
    /** Hook to populate report (called from mixin fns) */
    populateReportForm () {
      this.preSelectCompareDate()
    },
    /**
     * Pull the compare date selected from a previous report (if defined) and set the
     * state of this form to match
     */
    preSelectCompareDate () {
      const preSelectedCompareDate = get(this, 'report.parameters.compareDate')
      if (preSelectedCompareDate) {
        this.compareDate = Moment.tz(preSelectedCompareDate, 'UTC')
      } else {
        // Default to beginning of last month UTC
        this.compareDate = Moment().tz('UTC').subtract(1, 'month').startOf('month')
      }
    },
    /** Build report params (called from mixin) */
    buildReportParameters () {
      const reportParameters = {}

      reportParameters.customerIds = map(this.customers, x => x.id)
      reportParameters.compareDate = Moment.tz(this.compareDate, 'UTC').startOf('day').format()

      return reportParameters
    },
    defaultReportName () {
      return `${this.$t('reports_ui.customer_metrics_report.name')} (${Moment().format('LLL')})`
    }
  }
}
</script>

<style scoped>

</style>
